<!-- チャットボタン -->
<div class="chat-button" [class.open]="isChatOpen" (click)="toggleChat()">
    <i class="fa" [ngClass]="{'fa-comments': !isChatOpen, 'fa-times': isChatOpen}"></i>
</div>

<!-- チャットボックス -->
<div class="chat-box" [class.open]="isChatOpen">
    <div class="chat-box-header">
        <div class="chat-title">PIgeon AI Chat</div>
        <div class="close-button" (click)="toggleChat()">
            <i class="fa fa-times"></i>
        </div>
    </div>

    <div class="chat-box-body" #chatBody>
        <div class="chat-messages">
            <div *ngFor="let message of messages" class="chat-bot-message" [ngClass]="{'chat-bot-user-message': message.type === 'user', 'chat-bot-ai-message': message.type === 'bot'}">
                <div class="chat-bot-message-icon">
                    <img *ngIf="message.type === 'bot'" src="assets/pigeon_RGB_small.png" alt="AI" class="bot-icon">
                    <i *ngIf="message.type === 'user'" class="fa fa-user user-icon"></i>
                </div>
                <div class="chat-bot-message-content">
                    <div [innerHTML]="message.content | safeHtml"></div>
                    
                    <!-- ボタンUI要素 -->
                    <div *ngIf="message.buttons && message.buttons.length > 0" class="chat-bot-ui-buttons">
                        <button *ngFor="let button of message.buttons" 
                                class="chat-bot-ui-button"
                                (click)="handleButtonClick(button)">
                            {{button}}
                        </button>
                    </div>
                    
                    <!-- チェックボックスUI要素 -->
                    <div *ngIf="message.checkboxes && message.checkboxes.length > 0" class="chat-bot-ui-checkboxes">
                        <div *ngFor="let option of message.checkboxes" class="chat-bot-ui-checkbox">
                            <input type="checkbox" [id]="'checkbox-' + option" (change)="handleCheckboxChange(option, $event.target.checked)">
                            <label [for]="'checkbox-' + option">{{option}}</label>
                        </div>
                    </div>
                    
                    <!-- プルダウンUI要素 -->
                    <div *ngIf="message.pulldown && message.pulldown.length > 0" class="chat-bot-ui-pulldown">
                        <select (change)="handlePulldownChange($event.target.value)">
                            <option value="" disabled selected>選択してください</option>
                            <option *ngFor="let option of message.pulldown" [value]="option">{{option}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="chat-box-footer">
        <textarea
            [(ngModel)]="inputMessage"
            (keyup)="handleKeyUp($event)"
            placeholder="メッセージを入力"
            rows="2"
        ></textarea>
        <button class="send-button" (click)="sendMessage()" [disabled]="isLoading">
            <i class="fa" [ngClass]="{'fa-paper-plane': !isLoading, 'fa-spinner fa-spin': isLoading}"></i>
        </button>
    </div>
</div>
